import {api} from '../../../shared';
import {
  ConsentsDocumentsFilter,
  ConsentsDocumentsResponse,
  CreateConsentDocumentDTO,
  ConsentDocumentDetailModel,
  CreateDocumentVersionDTO,
  ConsentDocumentVersion,
  EditConsentDocumentDTO,
  UpdateConsentDocumentParams,
  BenefactorConsentsResponse,
} from '../model';

export const consentsApi = {
  getDocuments: async (params: ConsentsDocumentsFilter): Promise<ConsentsDocumentsResponse> => {
    const {data} = await api.get<ConsentsDocumentsResponse>(`/api/consents/admin/documents`, {
      params,
    });
    return data;
  },

  createDocument: async (dto: CreateConsentDocumentDTO): Promise<void> => {
    await api.post('/api/consents/admin/documents', dto);
  },

  getDocumentById: async (documentId: string): Promise<ConsentDocumentDetailModel> => {
    const {data} = await api.get<ConsentDocumentDetailModel>(`/api/consents/admin/documents/${documentId}`);
    return data;
  },

  createDocumentVersion: async (documentId: string, dto: CreateDocumentVersionDTO): Promise<ConsentDocumentVersion> => {
    const {data} = await api.post<ConsentDocumentVersion>(`/api/consents/admin/documents/${documentId}/versions`, dto);
    return data;
  },

  prepareUpload: async (contentTypes: string[]): Promise<{items: Array<{id: string; url: string}>}> => {
    const {data} = await api.post<{items: Array<{id: string; url: string}>}>('/api/files/public/prepare-upload', {
      contentTypes,
    });
    return data;
  },

  updateDocument: async ({
    documentId,
    title,
    displayText,
    isDistinguished,
    isMandatory,
    order,
  }: UpdateConsentDocumentParams): Promise<ConsentDocumentDetailModel> => {
    const body: EditConsentDocumentDTO = {title, displayText, isDistinguished, isMandatory, order};
    const {data} = await api.put<ConsentDocumentDetailModel>(`/api/consents/admin/documents/${documentId}`, body);
    return data;
  },

  archiveDocument: async (documentId: string): Promise<void> => {
    await api.delete(`/api/consents/admin/documents/${documentId}`);
  },

  getBenefactorConsents: async (benefactorId: string): Promise<BenefactorConsentsResponse> => {
    const {data} = await api.get<BenefactorConsentsResponse>(`/api/consents/admin/benefactors/${benefactorId}`);
    return data;
  },
};
